export const selectSessionItems = state => Object.values(state.chat.chatRecords);
export const selectBaselineSessionItems = state => Object.values(state.chat.baseLineChatRecords);